import { blocks as standardBlocks } from 'blockly/blocks';
import { common } from 'blockly/core';

import { registerArduinoBlocks } from './arduino-blocks.js';
import { registerBeginnerBlocks } from './beginner-blocks.js';
import { registerTextBlocks } from './text-blocks.js';

let registered = false;

/** Register standard Blockly blocks plus Skyrover Arduino blocks */
export function registerAllBlocks(): void {
  if (registered) {
    return;
  }
  common.defineBlocks(standardBlocks);
  registerTextBlocks();
  registerBeginnerBlocks();
  registerArduinoBlocks();
  registered = true;
}

export { setActiveBoard, getActiveBoard, analogPinToCode } from './board-context.js';
export { registerArduinoBlocks } from './arduino-blocks.js';
export { registerBeginnerBlocks } from './beginner-blocks.js';
export { registerTextBlocks } from './text-blocks.js';
export {
  beginnerTimeToMilliseconds,
  formatBeginnerTimeLabel,
  normalizeBeginnerTimeValue,
  DEFAULT_BEGINNER_TIME,
  type BeginnerTimeUnit,
  type BeginnerTimeValue,
} from './beginner/constants.js';
export {
  readBeginnerTimeField,
  readBeginnerTimeMilliseconds,
  beginnerPinField,
  beginnerTimeField,
  beginnerTimeUnitField,
  getBeginnerPinOptions,
  getBeginnerButtonPinOptions,
} from './beginner/helpers/block-builders.js';
export {
  formatBeginnerPinLabel,
  type BeginnerPinRole,
  type BeginnerPinOption,
} from './beginner/pins/pin-selector.js';
export {
  beginnerDeviceField,
  getBeginnerDeviceOptions,
} from './beginner/devices/device-selector.js';
export {
  getBoardBeginnerDevices,
  getBoardBeginnerDevicesByKind,
  findBeginnerDevice,
  boardHasBeginnerDeviceKind,
} from './beginner/devices/board-device-registry.js';
export type {
  BeginnerDeviceKind,
  BeginnerDeviceDefinition,
  BeginnerDeviceMapping,
  BeginnerDeviceOption,
} from './beginner/devices/types.js';
export {
  oledDeviceField,
  createOledDeviceDropdown,
  oledPositionModeField,
  oledLineField,
  oledColumnField,
  oledXField,
  oledYField,
  oledSizeField,
  DISPLAY_POSITION_LINE_COLUMN,
  DISPLAY_POSITION_XY,
  OLED_ADDRESS_OPTIONS,
  OLED_TEXT_SIZE_OPTIONS,
  OLED_FILL_COLOR_OPTIONS,
} from './beginner/display/oled-fields.js';
export {
  updateOledPositionDetails,
  createOledPositionModeDropdown,
} from './beginner/display/oled-position.js';
export {
  tftDeviceField,
  createTftDeviceDropdown,
  displayColorField,
  tftPositionModeField,
  tftLineField,
  tftColumnField,
  tftXField,
  tftYField,
  tftSizeField,
  tftRadiusField,
  DISPLAY_COLOR_OPTIONS,
  DISPLAY_COLOR_HEX,
  TFT_TEXT_SIZE_OPTIONS,
  TFT_WIDTH,
  TFT_HEIGHT,
} from './beginner/display/tft-fields.js';
export {
  updateTftPositionDetails,
  createTftPositionModeDropdown,
} from './beginner/display/tft-position.js';
export { getLcdI2cUi, boardSupportsLcdParallel } from './beginner/display/lcd-i2c-ui.js';
export { getOledI2cUi } from './beginner/display/oled-i2c-ui.js';
export { getTftSpiUi } from './beginner/display/tft-spi-ui.js';
export {
  LCD_CONNECTION_PARALLEL,
  LCD_CONNECTION_I2C,
} from './beginner/display/display-helpers.js';
export { FieldBeginnerTime } from './beginner/fields/field-beginner-time.js';
export {
  SKYROVER_VARIABLE_CATEGORY,
  SKYROVER_VARIABLE_TYPES,
  getVariableCppType,
  registerSkyroverVariableToolbox,
} from './variableTypes.js';
export { attachSkyroverVariableCreatorBar } from './variableCreatorUi.js';
export { SkyroverConnectionChecker } from './connectionChecker.js';
